<template>
  <div :class="[`features-ecommerce-item-1`, className || ``]">
    <p class="duis-aute-irure-dolo-13 inter-normal-gull-gray-18px">{{ duisAuteIrureDolo }}</p>
    <img class="icon-check_mark-2" :src="iconCheck_Mark" alt="icon-check_mark" />
  </div>
</template>

<script>
export default {
  name: "X12",
  props: ["duisAuteIrureDolo", "iconCheck_Mark", "className"],
};
</script>

<style>
.features-ecommerce-item-1 {
  align-self: stretch;
  height: 36.99px;
  min-width: 431.6px;
  overflow: hidden;
  position: relative;
}

.duis-aute-irure-dolo-13 {
  left: 26px;
  letter-spacing: -0.25px;
  line-height: 27px;
  position: absolute;
  top: 4px;
  white-space: nowrap;
  width: 406px;
}

.icon-check_mark-2 {
  height: 12px;
  left: 0;
  position: absolute;
  top: 12px;
  width: 16px;
}

.features-ecommerce-item-1.features-ecommerce-item .duis-aute-irure-dolo-13 {
  width: 405px;
}
</style>
